import { PageType, ProductFieldObject, ProductImpressions } from 'src/types';

export const FEATURED_PRODUCT_VISIBILITY_NAME = 'featuredProduct';

export type FeaturedProductImpressionEvent = ProductImpressions<'Product Impressions'>;

export interface FeaturedProductClick {
  event: 'product_clicks';
  event_category: 'Featured Product';
  event_action: 'Product Click';
  event_label: 'Shop this item';
  ecommerce: {
    click: {
      actionField: {
        list: `${string} - ${string} - featured product`;
      };
      products: [ProductFieldObject<PageType>];
    };
  };
}

export interface FeaturedProductOutOfStockEvent {
  event: 'custom_event';
  event_category: 'Featured Product';
  event_action: 'Out of stock';
  event_label: string;
}
